export default "__VITE_PUBLIC_ASSET__0ba7609d__"